import { PostTypeEnum } from "../enums/post.enum";

export const FEED_QUERY_KEYS = {
  all: ["feeds"] as const,
  postsList: (postType?: PostTypeEnum) => [...FEED_QUERY_KEYS.all, "posts", "list", postType] as const,
  postData: (postId: number) => [...FEED_QUERY_KEYS.all, "posts", "detail", postId] as const,
  comments: (postId: number) => [...FEED_QUERY_KEYS.postData(postId), "comments"] as const,
  commentData: (commentId: number) => [...FEED_QUERY_KEYS.all, "comments", "detail", commentId] as const,
  commentsList: () => [...FEED_QUERY_KEYS.all, "comments", "list"] as const,
  tags: () => ["tags"],
};
